import axios, { AxiosError } from 'axios';
import Settings from '@/config/Settings';
import AuthController from '@/controllers/AuthController';
import ServiceResponse from '@/models/ServiceResponse';
import AxiosHelper from '@/util/AxiosHelper';
import Response from '@/models/Response';
import Service from '@/models/Service';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common = { 'Content-Type': 'application/json' };

export default class ServiceController {
  private static readonly baseUrl = Settings.idUrl + `/api/services/`;

  public static async getServices(accessToken: string, refreshing = false): Promise<Response> {
    return await axios
      .get(`${this.baseUrl}available?clientId=USER_PORTAL`, { headers: { Authorization: accessToken } })
      .then((response) => {
        if (response.status === 200) {
          return ServiceResponse.buildSuccesResponse(response.data as Service[], accessToken);
        } else {
          return ServiceResponse.buildFailedResponse(
            `Expected status 200 but got ${response.status}`,
            `Verwachte status is 200, maar ontvangen status is ${response.status}`
          );
        }
      })
      .catch(async (error: Error | AxiosError) => {
        if (!refreshing) {
          const response = await AuthController.refresh();
          if (response && !(response instanceof Response)) {
            const data = response.data as Record<string, string>;
            return await ServiceController.getServices(data.access_token, true);
          }
          return response;
        } else {
          return AxiosHelper.handleErrorResponse(error);
        }
      });
  }
}
